import { faCircleCheck } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "antd";
// import React, { useEffect } from "react";

export const AuthSuccess = () => {
  const params = new URLSearchParams(window.location.search);
  const code = params.get("code");

  const shouldShowAppButton = Boolean(code && !window.opener);
  const isAndroid = /Android/i.test(navigator.userAgent);
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  const encodedCode = code ? encodeURIComponent(code) : "";

  const httpsAppLinkUrl = `https://app.surfingcre.com/auth-success/?code=${encodedCode}`;
  const customSchemeUrl = `surfingcre://auth-success?provider=tiktok&code=${encodedCode}`;
  const androidIntentUrl = `intent://auth-success?provider=tiktok&code=${encodedCode}#Intent;scheme=surfingcre;package=com.surfingcre.app;end`;

  const handleOpenApp = () => {
    if (!code) return;

    if (isAndroid) {
      window.location.href = androidIntentUrl;
      return;
    }

    if (isIOS) {
      window.location.href = customSchemeUrl;
      return;
    }

    window.location.href = httpsAppLinkUrl;
  };

  // useEffect(() => {
  //   const params = new URLSearchParams(window.location.search);
  //   const code = params.get("code");

  //   if (!code) return;
  //   if (window.opener) return;

  //   // 모바일 외부 브라우저 -> 앱 (딥링크)
  //   const deeplinkUrl = `surfingcre://auth-success?provider=tiktok&code=${encodeURIComponent(
  //     code
  //   )}`;

  //   window.location.href = deeplinkUrl;
  // }, []);

  return (
    <div className="w-full h-screen flex flex-col justify-center items-center text-center">
      <FontAwesomeIcon
        icon={faCircleCheck}
        className="text-[#1677FF] mb-4 text-[60px]"
      />
      <h1 className="text-[24px] mb-3">인증이 완료되었습니다!</h1>
      {/* <p className="text-[16px] text-[#666]">창을 닫고 계속 진행해 주세요.</p> */}
      {shouldShowAppButton ? (
        <>
          <p className="text-[16px] text-[#666] mb-14">
            앱으로 돌아가 계속 진행해 주세요.
          </p>
          <Button type="primary" size="large" onClick={handleOpenApp}>
            앱으로 돌아가기
          </Button>
        </>
      ) : (
        <p className="text-[16px] text-[#666]">창을 닫고 계속 진행해 주세요.</p>
      )}
    </div>
  );
};
